import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>
  판교 사는 주니어 개발자 입니다. 효과적인 정보전달을 위한 UI, 사용성 높은
  모듈설계를 고민합니다.
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      